<template>
  <div
    class="inline-flex items-stretch replace-document-control"
    :class="{ 'opacity-100': isLoading }"
  >
    <label
      :for="inputId"
      class="btn btn-neutral btn-xs transition-none replace-document-button"
      :class="{ 'opacity-100': isLoading }"
    >
      <div class="flex items-center justify-between w-full h-full">
        <span class="flex items-center space-x-2 w-full justify-center text-white">
          {{ message }}
        </span>
      </div>
    </label>
    <form
      ref="form"
      class="hidden"
    >
      <input
        :id="inputId"
        ref="input"
        name="files[]"
        type="file"
        :accept="acceptFileTypes"
        @change="upload()"
      >
    </form>
  </div>
</template>

<script>
import Upload from './upload'

export default {
  name: 'ReplaceDocument',
  inject: ['baseFetch', 't', 'backgroundColor'],
  props: {
    templateId: {
      type: [Number, String],
      required: true
    },
    authenticityToken: {
      type: String,
      required: false,
      default: ''
    },
    acceptFileTypes: {
      type: String,
      required: false,
      default: 'image/*, application/pdf, application/zip, application/json'
    }
  },
  emits: ['success'],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    inputId () {
      return 'el' + Math.random().toString(32).split('.')[1]
    },
    uploadUrl () {
      return `/templates/${this.templateId}/documents`
    },
    message () {
      if (this.isLoading) {
        return this.t('uploading_')
      } else {
        return this.t('replace')
      }
    }
  },
  methods: {
    upload: Upload.methods.upload
  }
}
</script>
